export default function install (Vue) {
  const that = this

  if (install.installed) return
  install.installed = true

  Object.defineProperty(Vue.prototype, '$ultronApi', {
    get () { return that.instance }
  })
}



// WEBPACK FOOTER //
// ./src/apis/ultron-api/install.js